import { useState } from 'react'
import cx from 'classnames'
import { PlusOutlined } from '@ant-design/icons'

import { Layout } from 'components/Shared'
import TableList from './TableList'
import TableListHeader from './TableListHeader'
import { useLocationContext } from './DeviceLocationContext'

function DeviceLocation() {
  const { loading } = useLocationContext()
  const [addLocation, setAddLocation] = useState(false)

  return (
    <Layout className='device-location'>
      <Layout.Header
        goBack
        bordered
        actionRight={
          <PlusOutlined
            disabled={loading}
            className={cx({ hoverable: !loading })}
            onClick={!loading ? () => setAddLocation(true) : undefined}
          />
        }
      >
        Device Location
      </Layout.Header>
      <Layout.Body>
        <TableListHeader />
        <TableList addLocation={addLocation} setAddLocation={setAddLocation} />
      </Layout.Body>
    </Layout>
  )
}

export default DeviceLocation
